export const checkPhone = (value) => {
    return !!(value && /^1[3456789]\d{9}$/.test(value) && value.length === 11);
}